import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Routes } from "../config";

const routes = [
  {
    name: <FormattedMessage id="navigation.dashboard" />,
    group: 'overview',
    icon: 'ni ni-shop',
    state: 'dashboardsCollapse',
    path: '/dashboard',
  },
  {
    name: <FormattedMessage id="navigation.admins" />,
    group: 'accounts',
    icon: 'fa fa-user-secret',
    state: 'clientsCollapse',
    path: Routes.ROUTE_ADMIN_MANAGE,
    activePaths: ['/admin/manage', '/admin/users', '/admin/groups'],
  },
  {
    name: <FormattedMessage id="navigation.clients" />,
    group: 'accounts',
    icon: 'fa fa-users',
    state: 'clientsCollapse',
    path: Routes.ROUTE_CLIENT_USERS,
    activePaths: ['/users'],
  },
  {
    name: <FormattedMessage id="navigation.organizations" />,
    group: 'accounts',
    icon: 'fa fa-building',
    state: 'clientsCollapse',
    path: Routes.ROUTE_CLIENT_ORGANIZATIONS,
    activePaths: ['/organizations'],
  },
  {
    name: <FormattedMessage id="navigation.orderManagement" />,
    group: 'operations',
    icon: 'fa fa-shopping-cart',
    state: 'orderManagementCollapse',
    path: Routes.ROUTE_CLIENT_ORDERS,
    activePaths: ['/orders', '/create-order'],
  },
  {
    name: <FormattedMessage id="navigation.documents" />,
    group: 'operations',
    icon: 'far fa-file',
    state: 'documentsCollapse',
    path: Routes.ROUTE_DOCUMENTS,
    activePaths: ['/documents', '/packages'],
  },
  {
    name: <FormattedMessage id="navigation.certificates" />,
    group: 'operations',
    icon: 'fa fa-id-card',
    state: 'documentsCollapse',
    path: Routes.ROUTE_CLIENT_CERTIFICATES,
  },
  {
    name: <FormattedMessage id="navigation.campaignManagement" />,
    group: 'engagement',
    icon: 'fa fa-shopping-cart',
    state: 'orderManagementCollapse',
    path: Routes.ROUTE_CLIENT_CAMPAIGN,
    activePaths: ['/campaigns', '/create-campaign'],
  },
  {
    name: <FormattedMessage id="navigation.emailCampaigns" />,
    group: 'engagement',
    icon: 'fa fa-envelope',
    state: 'emailCampaignsCollapse',
    path: Routes.ROUTE_CLIENT_EMAIL_CAMPAIGNS,
    activePaths: ['/email-campaigns', '/create-email-campaign'],
  },
  {
    name: <FormattedMessage id="navigation.appointments" />,
    group: 'service',
    icon: 'fa fa-calendar',
    state: 'appointmentCollapse',
    path: Routes.ROUTE_APPOINTMENTS,
    activePaths: ['/appointments'],
  },
  {
    name: <FormattedMessage id="navigation.tickets" />,
    group: 'service',
    icon: 'fa fa-tags',
    state: 'ticketsCollapse',
    path: Routes.ROUTE_CLIENT_TICKETS,
  },
  {
    name: <FormattedMessage id="navigation.reports.general" />,
    group: 'insights',
    icon: 'far fa-chart-bar',
    state: 'documentsCollapse',
    path: Routes.ROUTE_REPORTS_GENERAL,
    exact: true,
  },
  {
    name: <FormattedMessage id="navigation.reports.detailed" />,
    group: 'insights',
    icon: 'far fa-chart-bar',
    state: 'documentsCollapse',
    path: Routes.ROUTE_REPORTS,
    exact: true,
  },
];

export default routes;
